module.exports = __webpack_public_path__ + "static/img/dianTi.bde55fbb.jpg";